export const LENDING_ROUTE = '/';
export const PURCHASE_ROUTE = '/purchase';
export const PURCHASE_ROUTE_TEST = '/purchaseTest';
export const INSTRUCTION_ROUTE = '/instruction';
export const CONFIRM_ROUTE = '/confirm';
export const OPROS_ROUTE = '/survey';
export const SPPORT_ROUTE = '/support-app';
